import React from 'react';
import { YMInitializer } from 'react-yandex-metrika';

const YM_ACCOUNT = 23195053;
const YM_OPTIONS = {
    webvisor: true, 
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true
};

const YandexMetrica = () => (
    <YMInitializer accounts={[YM_ACCOUNT]} options={YM_OPTIONS} version="2" />
);

export default YandexMetrica;